// extracted by mini-css-extract-plugin
export default {"wrap":"YE-z","fullWidth":"ZE-z","hideOnDesktop":"_E-z","content":"aF-z","hasOpenedNav":"bF-z","crumbsList":"cF-z","dropdownsWrap":"dF-z"};